var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiSrUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1x2yemyy9a)",
    fill: "#E2582B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 17.057v3.984a.994.994 0 0 1-1 .996H3a1.002 1.002 0 0 1-1-.996v-3.984a.994.994 0 0 0-1-.996c-.265 0-.52.105-.707.292a.994.994 0 0 0-.293.704v3.984c0 .792.316 1.552.879 2.112.562.56 1.325.876 2.121.876h18c.796 0 1.559-.315 2.121-.876.563-.56.879-1.32.879-2.112v-3.984a.994.994 0 0 0-1-.996c-.265 0-.52.105-.707.292a.994.994 0 0 0-.293.704z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.707 5.566 14.121.998a3.013 3.013 0 0 0-4.242 0L5.293 5.566a.996.996 0 0 0 1.09 1.631 1 1 0 0 0 .324-.223L11 2.7v15.353a.994.994 0 0 0 1 .996 1.002 1.002 0 0 0 1-.996V2.699l4.293 4.275a1 1 0 0 0 1.72-.7.994.994 0 0 0-.306-.708z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1x2yemyy9a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .126)",
    d: "M0 0h24v23.902H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrUpload);
export default __webpack_public_path__ + "static/media/fi-sr-upload.5f80d55b0623f2c4d7a4de6cdbacda85.svg";
export { ForwardRef as ReactComponent };